import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { Alert, SpinnerLoader } from 'shared/ui'
import { Table } from 'shared/ui/TableNew'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type Integration } from 'entities/Integrations'
import { useIntegrationStoreMemo } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'
import { columns } from './columns.tsx'
import { IntegrationFrontSettingsStore } from './store/IntegrationFrontSettingsStore.ts'

import styles from './styles.module.scss'

type IIntegrationSlackSettings = {
  integration: Integration
}

export const IntegrationFrontSettings: FC<IIntegrationSlackSettings> = observer(
  ({ integration }) => {
    const entities = useEntitiesContext()
    const store = useIntegrationStoreMemo(IntegrationFrontSettingsStore, integration, entities)
    const { channelsRows, loading, tableStore } = store

    if (loading) {
      return <SpinnerLoader ariaLabel={'IntegrationSettings'} />
    }
    if (!channelsRows.length) {
      return (
        <div className={styles.container}>
          <Alert
            item={{
              type: 'infoLight',
              title: 'No inboxes mapped yet',
              desc: 'Go to Front and map your Salesmsg inboxes so messages start syncing',
            }}
          />
        </div>
      )
    }
    return (
      <div className={styles.container}>
        <Alert
          item={{
            type: 'infoLight',
            desc: "Add or edit inbox mappings in Front — they'll appear here once saved",
          }}
        />
        <Table
          virtualization
          ariaLabel={'FrontMappingsTable'}
          store={tableStore}
          columns={columns}
          rows={channelsRows}
          loading={loading}
          hidePagination
        />
      </div>
    )
  }
)
